import { sendAnalyticsHit } from "./app";
import { i18n } from "./texts";
import { getRedirectUrl } from "./utils";

export const disableCloseButton = () => {
  // We have multiple links (in error messages) where you can close the flow,
  // so we need a specific target for the actual close button.
  const closeButton = document.querySelectorAll("[data-close-button]");
  closeButton.forEach((cb) => cb.classList.add("navbar__close-button--hidden"));
};

export const setupCloseButton = (
  sessionId: string,
  shouldRedirect: boolean,
  locale: string,
  customReturnUrl?: string,
) => {
  const closeButton = document.querySelectorAll("[data-close-button]");
  closeButton.forEach((cb) =>
    cb.addEventListener("click", function () {
      setUpModal(locale);
    }),
  );

  const toClose = document.querySelectorAll("[data-to-close]");
  toClose.forEach((c) => {
    c.addEventListener("click", function (_) {
      document.getElementById("close-modal")?.classList.remove("close-modal--visible");
    });
  });

  document.getElementById("t-c-br")?.addEventListener("click", function () {
    if (shouldRedirect) {
      const url = getRedirectUrl(sessionId, "close", customReturnUrl);
      window.location.href = url;
    }
  });

  const close = document.querySelectorAll("[data-close]");
  close.forEach((c) =>
    c.addEventListener("click", function (_) {
      const formValue = (document.querySelector('input[name="reason"]:checked') as HTMLInputElement)?.value;
      if (formValue.length > 0) {
        const optional = document.querySelectorAll('input[name="optional"]') as NodeListOf<HTMLInputElement>;
        let opt: string | null = null;
        optional.forEach((e: HTMLInputElement) => {
          if (e.value.length > 0) {
            opt = e.value;
            return;
          }
        });

        sendAnalyticsHit(sessionId, { reason: formValue, details: opt || "" });

        document.getElementById("close-form-form")?.classList.remove("close-form__container--visible");
        document.getElementById("close-form-thanks")?.classList.add("close-form__container--visible");

        if (shouldRedirect) {
          const url = getRedirectUrl(sessionId, "close", customReturnUrl);
          window.location.href = url;
        }
      }
    }),
  );
};

export const showFeedbackForm = (locale: string) => {
  const txt = i18n[locale];

  document.getElementById("close-form-title")!.innerText = txt.feedback.title;

  document.getElementById("t-c-h")!.innerText = txt.feedback.header;
  document.getElementById("lbl-pb-pix")!.innerText = txt.feedback.problemPix;
  document.getElementById("lbl-pb-qr")!.innerText = txt.feedback.problemQR;
  document.getElementById("lbl-pb-tr")!.innerText = txt.feedback.problemTrust;
  document.getElementById("lbl-ch-m")!.innerText = txt.feedback.changeOfMind;
  document.getElementById("lbl-other")!.innerText = txt.feedback.other;

  const submitAndClose = document.getElementById("t-c-bc");
  submitAndClose!.innerText = txt.feedback.submitAndClose;

  document.getElementById("t-c-br")!.innerText = txt.feedback.return;

  document.getElementById("t-c-t")!.innerText = txt.feedback.feedbackThanks;

  let defaultValue: string = "";
  let prev: HTMLInputElement | null = null;
  const radios = document.querySelectorAll('input[name="reason"]') as NodeListOf<HTMLInputElement>;
  radios.forEach((r: HTMLInputElement, n: number) => {
    if (r.checked && r.value.length > 0) {
      defaultValue = r.value;
      const current = document.getElementById(`opt-close-${n}`) as HTMLInputElement;
      current?.classList.add("close-form__opt-input--visible");
      prev = current;
      return;
    }
  });

  const inputs = document.querySelectorAll('input[name="reason"]') as NodeListOf<Element>;
  const optionals = document.querySelectorAll('input[name="optional"]') as NodeListOf<HTMLInputElement>;

  for (let i = 0; i < 5; i++) {
    inputs[i].addEventListener("change", function (_: Event) {
      prev?.classList.remove("close-form__opt-input--visible");
      if (prev) (document.getElementById(prev.id) as HTMLInputElement).value = "";
      optionals[i].value = "";
      optionals[i].placeholder = txt.feedback.placeholder;

      const elem = document.getElementById(`opt-close-${i}`) as HTMLInputElement;
      elem?.classList.add("close-form__opt-input--visible");

      submitAndClose?.classList.remove("button--disabled");
      submitAndClose?.classList.add("button--primary");
      prev = elem;
    });
  }

  if (defaultValue.length === 0) {
    submitAndClose?.classList.remove("button--primary");
    submitAndClose?.classList.add("button--disabled");
  }

  document.getElementById("close-form")?.classList.add("close-form--visible");
};

export const setUpModal = (locale: string) => {
  const txt = i18n[locale];
  document.getElementById("close-modal")?.classList.add("close-modal--visible");

  document.getElementById("close-modal-title")!.innerText = txt.feedback.cancelAsk;
  document.getElementById("close-modal-info")!.innerText = txt.feedback.cancelInfo;
  const modalButton = document.getElementById("m-c-bc");
  modalButton!.innerText = txt.feedback.cancelConfirm;

  const modalClose = document.getElementById("m-c-br");
  modalClose!.innerText = txt.feedback.resume;

  modalButton?.addEventListener("click", function () {
    document.getElementById("close-modal")?.classList.remove("close-modal--visible");
    showFeedbackForm(locale);
  });

  modalClose?.addEventListener("click", function () {
    document.getElementById("close-modal")?.classList.remove("close-modal--visible");
  });
};
